import { memo } from "react";
import PropTypes from "prop-types";
import { addDofollowToAnchors } from "../utils/modifyHtmlLinks";

const SubServicesDetails = memo(({ serviceIntro, className = "" }) => {
  return (
    <section
      className={`w-full self-stretch flex flex-row items-start justify-end px-6 sm:px-6 lg:px-20 py-[40px] lg:py-[60px] box-border text-text-primary max-w-[1600px] mx-auto ${className}`}
    >
      <div className="self-stretch flex flex-col lg:flex-row items-start justify-start gap-6 max-w-full shrink-0">
        {serviceIntro?.title && (
          <div className="w-full lg:w-1/3 flex flex-col items-start justify-start p-0 box-border max-w-full">
            <h2 className="m-0 relative text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] font-medium">
              {serviceIntro?.title}
            </h2>
          </div>
        )}
        <div
          className="w-full flex-1 relative text-[16px] leading-[150%] inline-block max-w-full rich-text"
          dangerouslySetInnerHTML={{
            __html: addDofollowToAnchors(serviceIntro?.description) || "",
          }}
        />
        {/* {serviceIntro?.description}
        </div> */}
      </div>
    </section>
  );
});

SubServicesDetails.propTypes = {
  className: PropTypes.string,
};

export default SubServicesDetails;
